let EnvironmentVars = {
    baseUrl:'/api',
    credentialsPolicy:'same-origin'
}
export { EnvironmentVars }